import styled from "styled-components";

export const Layer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
`;
